import { useIntl } from 'react-intl';
import {
  ProfileMenuContainer,
  WelcomeText,
  MenuItem as StyledMenuItem,
  AddCompanyButton,
} from './style';
import useQueryApiClient from 'utils/useQueryApiClient';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../hooks/useAuth';
import { Modal } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { publicPath } from 'enums/publicRoutes';
import { adminPath } from 'enums/adminRoutes';

interface MenuItemProps {
  onClick?: () => void;
  children: React.ReactNode;
}

const MenuItem = ({ onClick, children }: MenuItemProps) => (
  <StyledMenuItem className="profile-menu-item-wrapper">
    <div className="profile-menu-item" onClick={onClick}>
      <div className="profile-menu-item-content">{children}</div>
      <RightOutlined className={'profile-menu-item-icon'} />
    </div>
  </StyledMenuItem>
);

interface ProfileMenuProps {
  fullName: string;
}

const ProfileMenu = ({ fullName }: ProfileMenuProps) => {
  const navigate = useNavigate();
  const [modal, contextHolder] = Modal.useModal();

  const intl = useIntl();
  const { logout, user } = useAuth();

  const { data } = useQueryApiClient({
    request: {
      url: '/api/v2/user/order',
      data: {
        count: true,
      },
    },
  });

  const handleLogout = async () => {
    await logout();
  };

  const config = {
    title: intl.formatMessage({ id: 'roles.add_farm_information' }),
    icon: null,
    cancelText: intl.formatMessage({ id: 'general.cancel' }),
    okText: intl.formatMessage({ id: 'general.logout' }),
    onOk: () => logout(),
  };

  const isAdminPanel = user?.isAdmin || user?.isFarmOwner;
  return (
    <ProfileMenuContainer>
      {contextHolder}
      <WelcomeText>
        {intl.formatMessage({ id: 'general.hello' })}, <br />
        <span>{fullName}!</span>
      </WelcomeText>
      <hr />
      <MenuItem onClick={() => navigate(publicPath.profile('my_orders'))}>
        {intl.formatMessage({ id: 'general.my_orders' })}
        <span className="order-count">({data})</span>
      </MenuItem>
      <MenuItem onClick={() => navigate(publicPath.profile('profile_information'))}>
        {intl.formatMessage({ id: 'general.profile_information' })}
      </MenuItem>
      {isAdminPanel && (
        <>
          <MenuItem>
            <a className={'admin-link'} href={adminPath.roles()}>
              {intl.formatMessage({ id: 'roles.my_roles' })}
            </a>
          </MenuItem>
          <MenuItem>
            <a className={'admin-link'} href={adminPath.base()}>
              {intl.formatMessage({ id: 'general.admin' })}
            </a>
          </MenuItem>
        </>
      )}
      <MenuItem onClick={handleLogout}>
        {intl.formatMessage({ id: 'general.exit' })}
      </MenuItem>
      <AddCompanyButton
        onClick={() => modal.confirm(config)}
        label={intl.formatMessage({ id: 'farms.add_farm' })}
      />
    </ProfileMenuContainer>
  );
};

export default ProfileMenu;
